import { PLATFORM_ID, Injectable, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare let gtag: (a,b,c) => void;

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private platformId = inject<Record<string, unknown>>(PLATFORM_ID);


  public emitEvent(action: string, category: string = undefined, value: number = null, label: string = null ): void {
    if (isPlatformBrowser(this.platformId)) {
      gtag('event', action, {
        event_category: category,
        event_label: label,
        value
      });
    }
  }
}
